import DashboardMetrics from "./DashboardMetrics";

const Dashboard = () => {
  return (
    <div>
      <DashboardMetrics />
    </div>
  );
};

export default Dashboard;